// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SebastianTileWrapper_wrapper__MmcQD"};